export default __webpack_public_path__ + "static/media/mimo_cover.f861ccb0.gif";